import { Typography } from "@material-ui/core"

const Receipt = (props) => {

  return ( <>
    <Typography>
      Once your song is ready, we’ll send you a direct link to download it—quick, easy, and hassle-free. If you’ve chosen the streaming add-on, we’ll also upload it to Spotify and/or Amazon Music so you can listen anytime, anywhere (and flex on your friends).
    </Typography>
  </> )
}

export default Receipt
